import type { WikiBlock } from "../types";

/** SSOT note: in-app pitch summary of threat/HP AI (not full code dump). */
export const threatResponseBlocks: readonly WikiBlock[] = [
  {
    type: "callout",
    tone: "info",
    text: "보스방이든 잔챙이 웨이브든, 영웅은 “내 발 근처에 위험이 얼마나 몰려 있나”만 보고 같은 방식으로 반응합니다. 전투 종류마다 AI를 따로 만들지 않습니다.",
  },
  { type: "h2", text: "왜 이렇게 만들었나" },
  { type: "h3", text: "플레이에서 보이고 싶은 것" },
  {
    type: "ul",
    items: [
      "탱커가 앞에서 적을 붙잡다가, 피가 빠지면 힐러 쪽으로 한 발 물러난다",
      "레인저는 적 무리 한가운데에 서서 맞지 않고, 화살 거리에서 도와준다",
      "“적이 빨리 죽어서 위험해 안 보임”이 아니라, 뒤로 빠지며 싸우는 모습이 보여야 한다",
      "파티 전원이 맵 끝까지 도망만 가다 구석에서야 싸우면 실패다",
    ],
  },
  { type: "h3", text: "디자인 의도" },
  {
    type: "ul",
    items: [
      "위험은 “내 옆·앞에 적이 얼마나 붙어 있나”로 본다",
      "직업마다 도망 거리가 다르다. 탱은 조금만, 원거리는 멀리 — 그래도 탱커 근처는 지킨다",
      "“피가 이만큼 남으면 빼라”는 숫자로 조절한다",
      "성격 재능(직감·통찰·유대)과는 다른 층이다. 여기는 “발 밑이 위험한가”에 대한 자리 잡기 규칙이다",
    ],
  },
  { type: "h2", text: "탱커 생각 순서" },
  {
    type: "ul",
    items: [
      "피가 너무 적다 → 힐러 쪽으로 빠진다",
      "적 무리에 둘러싸여 맞는다 → 짧게 한 발",
      "적은 많은데 아직 멀다 → 가까운 적을 붙잡는다",
      "그 외 → 앞에서 버틴다 (중체력에서는 뒤로만 도망이 기본이 아님)",
    ],
  },
  { type: "h2", text: "레인저 생각 순서" },
  {
    type: "ul",
    items: [
      "발 밑이 위험하다 → 물러나며 쏜다",
      "이미 화살 거리다 → 그 자리에서 유지",
      "너무 멀다 → 쏘러 다가간다",
      "멀리서 가만히만 있으면 실패다",
    ],
  },
  { type: "h2", text: "숫자 손잡이" },
  {
    type: "table",
    headers: ["손잡이", "지금", "뜻"],
    rows: [
      ["탱 HP 후퇴 임계", "25%", "이 피 아래면 탱커 후퇴"],
      ["팩 밀도", "2명", "이만큼 모이면 무리로 본다"],
      ["탱 스텝", "짧게", "탱커는 조금만 빠지게"],
      ["원거리 이격", "멀리", "레인저는 더 멀리 카이트"],
      ["앵커 목줄", "탱 근처", "원거리가 맵 끝으로만 안 가게"],
    ],
  },
];
